const $27650f335af3f4c5$export$c78050b59d0802b7 = 'tv2-menu';
const $27650f335af3f4c5$export$5612978d35c19998 = 'tv2-menu-top-nav';
const $27650f335af3f4c5$export$850b00fcb503587c = 'tv2-menu-mega-menu-toggle';
const $27650f335af3f4c5$export$e0893ac102bd73d8 = 'tv2-menu--disable-mobile-top-menu-categories';
const $27650f335af3f4c5$export$3a4b1044630b7106 = 'tv2-menu--minimized';



const $0e87754269846f8f$export$dde0441bd4a6ded8 = ()=>{
    const $menu = document.getElementById((0, $27650f335af3f4c5$export$c78050b59d0802b7));
    const $topNav = document.getElementById((0, $27650f335af3f4c5$export$5612978d35c19998));
    var _$menu_getBoundingClientRect_height;
    const menuHeight = Math.ceil((_$menu_getBoundingClientRect_height = $menu === null || $menu === void 0 ? void 0 : $menu.getBoundingClientRect().height) !== null && _$menu_getBoundingClientRect_height !== void 0 ? _$menu_getBoundingClientRect_height : 0);
    var _$topNav_getBoundingClientRect_height;
    const topNavHeight = Math.ceil((_$topNav_getBoundingClientRect_height = $topNav === null || $topNav === void 0 ? void 0 : $topNav.getBoundingClientRect().height) !== null && _$topNav_getBoundingClientRect_height !== void 0 ? _$topNav_getBoundingClientRect_height : 0);
    const menuExpandThresholdPx = 30;
    let hidden = false;
    let lastScrollTop = window.scrollY;
    document.addEventListener("scroll", ()=>{
        const scrollTop = window.scrollY;
        const scrollDelta = Math.abs(scrollTop - lastScrollTop);
        const scrollDirection = lastScrollTop < scrollTop ? 'DOWN' : 'UP';
        if (scrollDirection === 'DOWN') {
            if (scrollTop > menuHeight) window.requestAnimationFrame(()=>{
                if (!hidden) {
                    hidden = true;
                    $menu === null || $menu === void 0 ? void 0 : $menu.classList.add((0, $27650f335af3f4c5$export$3a4b1044630b7106));
                    $menu === null || $menu === void 0 ? void 0 : $menu.style.setProperty('transform', 'translateY(' + -topNavHeight + 'px)');
                    const downEvent = new CustomEvent('tv2-menu:scroll-down', {});
                    document.dispatchEvent(downEvent);
                }
            });
        }
        if (scrollDirection === 'UP') {
            if (scrollDelta > menuExpandThresholdPx || scrollTop < menuHeight) window.requestAnimationFrame(()=>{
                if (hidden) {
                    hidden = false;
                    $menu === null || $menu === void 0 ? void 0 : $menu.classList.remove((0, $27650f335af3f4c5$export$3a4b1044630b7106));
                    $menu === null || $menu === void 0 ? void 0 : $menu.style.setProperty('transform', 'translateY(0)');
                    const upEvent = new CustomEvent('tv2-menu:scroll-up', {});
                    document.dispatchEvent(upEvent);
                }
            });
        }
        lastScrollTop = scrollTop;
    });
};




const $8ffc0864d4b30959$var$track = (event)=>{
    var _window_snowplowTracker_coreTracker, _window_snowplowTracker;
    (_window_snowplowTracker = window.snowplowTracker) === null || _window_snowplowTracker === void 0 ? void 0 : (_window_snowplowTracker_coreTracker = _window_snowplowTracker.coreTracker) === null || _window_snowplowTracker_coreTracker === void 0 ? void 0 : _window_snowplowTracker_coreTracker.trackUserLogin({
        userId: event.userID,
        userAction: event.eventAction
    });
};
const $8ffc0864d4b30959$export$8cda87936ff9c413 = (action, userId = '')=>{
    $8ffc0864d4b30959$var$track({
        event: 'loginEvent',
        eventCategory: 'Login',
        eventAction: action,
        userID: userId
    });
};


const $890a1eee0f43845a$export$8e20c552061e64bb = (value)=>{
    return typeof value === 'object' && value !== null && typeof value.category === 'string' && typeof value.action === 'string';
};


const $1b3bef11b946f0c1$export$18986b1d7d261785 = ()=>{
    const { callbackUrl: callbackUrl, domain: domain, clientId: clientId, userApiUrl: userApiUrl } = window.AUTH0_CONFIG;
    if (!window.auth0) return Promise.reject('auth0 script not loaded');
    const buildRedirectUri = (internalUrl)=>`${callbackUrl}?internalUrl=${encodeURIComponent(internalUrl)}`;
    return window.auth0.createAuth0Client({
        domain: domain,
        clientId: clientId,
        cacheLocation: 'localstorage',
        useRefreshTokens: true,
        useRefreshTokensFallback: true,
        authorizationParams: {
            audience: `https://${domain}`,
            redirect_uri: buildRedirectUri(location.href.toString())
        }
    }).then((auth0Client)=>{
        const login = async function(arg1, arg2, arg3) {
            const redirectUrl = arg3 ? buildRedirectUri(arg3) : undefined;
            if ((0, $890a1eee0f43845a$export$8e20c552061e64bb)(arg1)) {
                const reason = arg1;
                const appStatePayload = (0, $242f61281a4fc053$export$71511d61b312f219)({}, reason);
                const opts = {
                    appState: appStatePayload,
                    authorizationParams: (0, $242f61281a4fc053$export$71511d61b312f219)({}, redirectUrl && {
                        redirect_uri: redirectUrl
                    })
                };
                await auth0Client.loginWithRedirect(opts);
            } else {
                const opts = {
                    authorizationParams: {}
                };
                const reasonToLoginCategory = typeof arg1 === 'string' ? arg1 : undefined;
                const reasonToLoginName = arg2;
                if (reasonToLoginCategory) opts.authorizationParams.reasonToLoginCategory = reasonToLoginCategory;
                if (reasonToLoginName) opts.authorizationParams.reasonToLoginName = reasonToLoginName;
                if (redirectUrl) opts.authorizationParams.redirect_uri = redirectUrl;
                await auth0Client.loginWithRedirect(opts);
            }
        };
        const logout = async function() {
            var _window_TV2, _window;
            const user = await ((_window = window) === null || _window === void 0 ? void 0 : (_window_TV2 = _window.TV2) === null || _window_TV2 === void 0 ? void 0 : _window_TV2.getLoggedInUser());
            const userId = user === null || user === void 0 ? void 0 : user.id;
            (0, $8ffc0864d4b30959$export$8cda87936ff9c413)('Logout Clicked', userId);
            // Clear coral tokens from localStorage
            localStorage.removeItem('coral_token');
            localStorage.removeItem('coral_token_expiry');
            await auth0Client.logout({
                logoutParams: {
                    returnTo: `${callbackUrl}?internalUrl=${encodeURIComponent(location.href.toString())}&logout=true`
                }
            });
        };
        const isAuthenticated = async function() {
            return await auth0Client.isAuthenticated();
        };
        const getLoggedInUser = async function() {
            try {
                const token = await auth0Client.getTokenSilently({
                    authorizationParams: {
                        redirect_uri: location.origin
                    }
                });
                if (!token) return;
                const userResponse = await fetch(userApiUrl, {
                    method: 'get',
                    credentials: 'include',
                    headers: new Headers({
                        Authorization: 'Bearer ' + token
                    })
                });
                const userData = await userResponse.json();
                return userData;
            } catch (e) {
                return;
            }
        };
        const getToken = async function() {
            return await auth0Client.getTokenSilently({
                authorizationParams: {
                    redirect_uri: location.origin
                }
            });
        };
        const verifyEmail = async function() {
            try {
                var _window_TV2;
                const token = await ((_window_TV2 = window.TV2) === null || _window_TV2 === void 0 ? void 0 : _window_TV2.getToken());
                const response = await fetch(`${userApiUrl}verifyEmail`, {
                    method: 'POST',
                    headers: new Headers({
                        Authorization: 'Bearer ' + token
                    })
                });
                if (!response.ok || response.status !== 204) throw new Error(`User verification email failed: ${response.status}`);
                const user = await window.TV2.getLoggedInUser();
                return {
                    success: true,
                    message: 'Verification email sent',
                    email: user === null || user === void 0 ? void 0 : user.email
                };
            } catch (e) {
                console.error('Menu: Error verifying email:', e);
                return {
                    success: false,
                    message: e.message
                };
            }
        };
        window.TV2 = (0, $258427eeb49655b2$export$71511d61b312f219)((0, $242f61281a4fc053$export$71511d61b312f219)({}, window.TV2), {
            login: login,
            logout: logout,
            isAuthenticated: isAuthenticated,
            getLoggedInUser: getLoggedInUser,
            getToken: getToken,
            verifyEmail: verifyEmail
        });
        return auth0Client;
    });
};


const $fdce418d1cd7b5bb$var$RECENT_LOGIN_CHECK_COOKIE = 'tv2HasCheckedLogin';
const $fdce418d1cd7b5bb$export$6edebfff5396a41b = ()=>{
    document.cookie = `${$fdce418d1cd7b5bb$var$RECENT_LOGIN_CHECK_COOKIE}=1; domain=${window.location.hostname}; path=/; max-age=${1800}`;
};
const $fdce418d1cd7b5bb$export$693d6d909aa70dae = ()=>document.cookie.split(';').some((item)=>item.trim().startsWith(`${$fdce418d1cd7b5bb$var$RECENT_LOGIN_CHECK_COOKIE}=`));
const $fdce418d1cd7b5bb$export$4be65e66cfa2648a = (name)=>{
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [cookieName, cookieValue] = cookie.trim().split('=');
        if (cookieName === name) return cookieValue;
    }
    return null;
};



const $35c27816a19ac90b$export$213a2dc2015f93c1 = (auth0Client)=>{
    const url = new URL(location.href);
    const searchParams = url.searchParams;
    const isRedirectCallback = searchParams.has('code') && searchParams.has('state');
    return isRedirectCallback ? auth0Client.handleRedirectCallback().then((result)=>{
        const appState = result === null || result === void 0 ? void 0 : result.appState;
        if (appState && (0, $890a1eee0f43845a$export$8e20c552061e64bb)(appState)) {
            var _window_snowplowTracker;
            if (((_window_snowplowTracker = window.snowplowTracker) === null || _window_snowplowTracker === void 0 ? void 0 : _window_snowplowTracker.coreTracker) && typeof window.snowplowTracker.coreTracker.trackLoginSuccess === 'function') window.snowplowTracker.coreTracker.trackLoginSuccess(appState);
            else console.warn("Login tracking: trackLoginSuccess is not available.");
        }
        url.searchParams.delete('code');
        url.searchParams.delete('state');
        history.replaceState({}, document.title, url.toString());
        return auth0Client;
    }) : Promise.resolve(auth0Client);
};


const $86bc53116c439107$export$da4fc2bf424da4ca = ()=>{
    (0, $1b3bef11b946f0c1$export$18986b1d7d261785)().then((0, $35c27816a19ac90b$export$213a2dc2015f93c1)).then(async (auth0Client)=>{
        var _window_TV2, _window;
        /*
       * This call to getTokenSilently will identify whether there is a valid auth0 session.
       * E.g. if the user has logged in on another subdomain, this will authenticate the
       * user on the current subdomain as well.
       *
       * The tv2HasCheckedLogin cookie is used to avoid calling getTokenSilently on every page load.
       */ if (!(0, $fdce418d1cd7b5bb$export$693d6d909aa70dae)()) try {
            await auth0Client.getTokenSilently({
                authorizationParams: {
                    redirect_uri: location.origin
                }
            });
        } catch (_e) {
        // this is expected when there is no valid auth0 session and can be ignored
        } finally{
            (0, $fdce418d1cd7b5bb$export$6edebfff5396a41b)();
        }
        const user = await ((_window = window) === null || _window === void 0 ? void 0 : (_window_TV2 = _window.TV2) === null || _window_TV2 === void 0 ? void 0 : _window_TV2.getLoggedInUser());
        const userId = user === null || user === void 0 ? void 0 : user.id;
        $86bc53116c439107$var$updateUI(user);
        // Deprecated - still in use until all uses are updated to new event
        document.dispatchEvent(new CustomEvent('tv2-menu:auth0-ready', {
            detail: {
                app: false,
                isReady: true,
                userId: userId
            }
        }));
        // New event to take over for above event
        document.dispatchEvent(new CustomEvent('tv2-menu:auth-ready', {
            detail: {
                app: false,
                isReady: true,
                userId: userId
            }
        }));
    }).catch((e)=>{
        console.error('TV 2 Menu: Auth:', e.message);
    });
};
const $86bc53116c439107$var$updateUI = (user)=>{
    var _window_TV2;
    const $authBubble = document.getElementById('tv2-menu-auth-bubble');
    const $authLabel = document.getElementById('tv2-menu-auth-label');
    const $authLabelSecondary = document.getElementById('tv2-menu-auth-label--secondary');
    const $loginButton = document.getElementById('tv2-menu-login-btn');
    const $logoutButton = document.getElementById('tv2-menu-logout-btn');
    if ($loginButton) $loginButton.onclick = async function() {
        var _window_lab_metadata_tags, _window_lab_metadata, _window_TV2;
        if (user) {
            const $userProfileContextMenu = document.getElementById('tv2-menu-auth-context-menu');
            $userProfileContextMenu === null || $userProfileContextMenu === void 0 ? void 0 : $userProfileContextMenu.classList.toggle('tv2-menu__auth-menu--open');
        } else await ((_window_TV2 = window.TV2) === null || _window_TV2 === void 0 ? void 0 : _window_TV2.login('Navbar', (_window_lab_metadata = window.lab_metadata) === null || _window_lab_metadata === void 0 ? void 0 : (_window_lab_metadata_tags = _window_lab_metadata.tags) === null || _window_lab_metadata_tags === void 0 ? void 0 : _window_lab_metadata_tags.sectionTag));
    };
    if ($logoutButton) $logoutButton.onclick = (_window_TV2 = window.TV2) === null || _window_TV2 === void 0 ? void 0 : _window_TV2.logout;
    if ($authBubble && $authLabel) {
        if (user) {
            var _user_firstname, _user_firstname_split, _user_firstname1;
            $authBubble.classList.add('tv2-menu__auth-bubble--authenticated');
            var _user_firstname_;
            $authBubble.innerText = (_user_firstname_ = user === null || user === void 0 ? void 0 : (_user_firstname = user.firstname) === null || _user_firstname === void 0 ? void 0 : _user_firstname[0]) !== null && _user_firstname_ !== void 0 ? _user_firstname_ : '';
            var _user_firstname_split_;
            $authLabel.innerText = (_user_firstname_split_ = user === null || user === void 0 ? void 0 : (_user_firstname1 = user.firstname) === null || _user_firstname1 === void 0 ? void 0 : (_user_firstname_split = _user_firstname1.split(' ')) === null || _user_firstname_split === void 0 ? void 0 : _user_firstname_split[0]) !== null && _user_firstname_split_ !== void 0 ? _user_firstname_split_ : '';
            if ($authLabelSecondary) $authLabelSecondary.style.display = 'none';
        } else {
            $authLabel.innerText = 'Logg inn';
            $authBubble.classList.remove('tv2-menu__auth-bubble--authenticated');
        }
    }
};





const $97b4c742360fac72$export$5a86d273c3376191 = ()=>{
    const $menu = document.getElementById((0, $27650f335af3f4c5$export$c78050b59d0802b7));
    const $menuToggle = document.getElementById((0, $27650f335af3f4c5$export$850b00fcb503587c));
    const $menuCloseButton = document.querySelector('.tv2-menu__megamenu__close-button');
    const $html = document.querySelector('html');
    const initialHtmlOverflow = $html === null || $html === void 0 ? void 0 : $html.style.overflow;
    const currentUrl = window.location.href;
    window.TV2 = (0, $258427eeb49655b2$export$71511d61b312f219)((0, $242f61281a4fc053$export$71511d61b312f219)({}, window.TV2), {
        toggleNavigation: function() {
            $html === null || $html === void 0 ? void 0 : $html.style.setProperty('overflow', ($html === null || $html === void 0 ? void 0 : $html.style.overflow) === 'hidden' ? initialHtmlOverflow !== null && initialHtmlOverflow !== void 0 ? initialHtmlOverflow : '' : 'hidden');
            $menuToggle === null || $menuToggle === void 0 ? void 0 : $menuToggle.classList.toggle('tv2-menu__megamenu__toggle--open');
            $menu === null || $menu === void 0 ? void 0 : $menu.classList.toggle('tv2-menu--open');
            $menuToggle === null || $menuToggle === void 0 ? void 0 : $menuToggle.focus();
        }
    });
    if ($menuToggle) $menuToggle.onclick = window.TV2.toggleNavigation;
    if ($menuCloseButton) $menuCloseButton.onclick = ()=>{
        window.TV2.toggleNavigation();
    };
    document.addEventListener('keyup', (event)=>{
        if (event.key === 'Escape' && ($menu === null || $menu === void 0 ? void 0 : $menu.classList.contains('tv2-menu--open'))) window.TV2.toggleNavigation();
    });
    $menu === null || $menu === void 0 ? void 0 : $menu.querySelectorAll('a').forEach(($link)=>{
        if ($link.href === currentUrl) $link.onclick = (event)=>{
            event.preventDefault();
            if ($menu === null || $menu === void 0 ? void 0 : $menu.classList.contains('tv2-menu--open')) window.TV2.toggleNavigation();
        };
        else $link.onclick = (event)=>{
            if ($menu === null || $menu === void 0 ? void 0 : $menu.classList.contains('tv2-menu--open')) window.TV2.toggleNavigation();
        };
    });
};



const $3b5dd35a8e8ee801$export$ca94e975f9255f98 = ()=>{
    const $menu = document.getElementById((0, $27650f335af3f4c5$export$c78050b59d0802b7));
    const $contextLogo = $menu === null || $menu === void 0 ? void 0 : $menu.querySelector('.tv2-menu__context-logo');
    $contextLogo === null || $contextLogo === void 0 ? void 0 : $contextLogo.addEventListener('click', (event)=>{
        const currentUrl = window.location.href;
        const linkUrl = $contextLogo === null || $contextLogo === void 0 ? void 0 : $contextLogo.href;
        if (currentUrl === linkUrl) {
            event.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'instant'
            });
        }
    });
};



const $ccd1fa24fcb118d8$export$d9b45b5588c57e64 = ()=>{
    const $menu = document.getElementById((0, $27650f335af3f4c5$export$c78050b59d0802b7));
    $menu === null || $menu === void 0 ? void 0 : $menu.classList.remove((0, $27650f335af3f4c5$export$e0893ac102bd73d8));
    $ccd1fa24fcb118d8$var$updateBodyPaddingTop($menu);
};
const $ccd1fa24fcb118d8$export$c8ddb059529fd30a = ()=>{
    const $menu = document.getElementById((0, $27650f335af3f4c5$export$c78050b59d0802b7));
    $menu === null || $menu === void 0 ? void 0 : $menu.classList.add((0, $27650f335af3f4c5$export$e0893ac102bd73d8));
    $ccd1fa24fcb118d8$var$updateBodyPaddingTop($menu);
};
const $ccd1fa24fcb118d8$var$updateBodyPaddingTop = ($menu)=>{
    var _$menu_getBoundingClientRect_height;
    const menuHeight = Math.round((_$menu_getBoundingClientRect_height = $menu === null || $menu === void 0 ? void 0 : $menu.getBoundingClientRect().height) !== null && _$menu_getBoundingClientRect_height !== void 0 ? _$menu_getBoundingClientRect_height : 0);
    document.body.style.paddingTop = menuHeight + 'px';
};


/*
 * Some sites that include the menu may use a fouc-prevention technique that hides body content while
 * all resources are loading. In these cases the menu height will be 0 until this content is displayed.
 * We therefore add this onClientHeight function to wait for the menu to have a client height before initialising
 * scroll logic and adding top padding to the body. We limit this sequence to 10 retries (1s).
 */ const $72d78183ba861693$var$MAX_RETRIES = 10;
const $72d78183ba861693$var$TIME_BETWEEN_RETRIES_MS = 100;
const $72d78183ba861693$export$89250341c2040c2d = ($el)=>{
    let retries = 0;
    const retry = ()=>{
        var _$el_getBoundingClientRect_height;
        const menuHeight = Math.round((_$el_getBoundingClientRect_height = $el === null || $el === void 0 ? void 0 : $el.getBoundingClientRect().height) !== null && _$el_getBoundingClientRect_height !== void 0 ? _$el_getBoundingClientRect_height : 0);
        if (menuHeight === 0 && retries < $72d78183ba861693$var$MAX_RETRIES) {
            retries++;
            return new Promise((resolve)=>setTimeout(resolve, $72d78183ba861693$var$TIME_BETWEEN_RETRIES_MS)).then(retry);
        }
        return Promise.resolve(menuHeight);
    };
    return retry();
};


/*
 * Check if the user is authenticated with Auth0
 */ const $ac9a226636de795d$var$MAX_RETRIES = 10;
const $ac9a226636de795d$var$TIME_BETWEEN_RETRIES_MS = 100;
const $ac9a226636de795d$export$eb86a8b8512b1ef2 = ()=>{
    let retries = 0;
    const retry = ()=>typeof window.auth0 !== 'object' && retries < $ac9a226636de795d$var$MAX_RETRIES ? new Promise((resolve)=>setTimeout(resolve, $ac9a226636de795d$var$TIME_BETWEEN_RETRIES_MS)).then(()=>{
            retries++;
            return retry();
        }) : Promise.resolve(true);
    return retry();
};




var $313a413ce328ff04$var$_window;
const $313a413ce328ff04$var$localstorage = (($313a413ce328ff04$var$_window = window) === null || $313a413ce328ff04$var$_window === void 0 ? void 0 : $313a413ce328ff04$var$_window.localStorage) || null;
const $313a413ce328ff04$export$93d719890ad66653 = (key)=>{
    const itemString = $313a413ce328ff04$var$localstorage === null || $313a413ce328ff04$var$localstorage === void 0 ? void 0 : $313a413ce328ff04$var$localstorage.getItem(key);
    if (!itemString) return null;
    const item = JSON.parse(itemString);
    const now = new Date();
    if (now.getTime() > item.expiry) {
        $313a413ce328ff04$var$localstorage === null || $313a413ce328ff04$var$localstorage === void 0 ? void 0 : $313a413ce328ff04$var$localstorage.removeItem(key);
        return null;
    }
    return item.value;
};
let $313a413ce328ff04$export$5aa524d86254b4f = (key, value, ttl = 2)=>{
    const now = new Date();
    const item = {
        value: value,
        expiry: now.getTime() + ttl * 3600000
    };
    $313a413ce328ff04$var$localstorage === null || $313a413ce328ff04$var$localstorage === void 0 ? void 0 : $313a413ce328ff04$var$localstorage.setItem(key, JSON.stringify(item));
};
let $313a413ce328ff04$export$baf306891f1b93bd = (key)=>{
    $313a413ce328ff04$var$localstorage === null || $313a413ce328ff04$var$localstorage === void 0 ? void 0 : $313a413ce328ff04$var$localstorage.removeItem(key);
};


const $8935bf2b06df93ed$export$407a6a3870454386 = ()=>{
    const { userApiUrl: userApiUrl } = window.AUTH0_CONFIG;
    const login = async function(reasonOrCategory, reasonName) {
        var _window_webkit_messageHandlers, _window_webkit, _window, _window_TV2JSBridge, _window1;
        let data;
        if (typeof reasonOrCategory === 'object' && reasonOrCategory !== null && 'category' in reasonOrCategory) {
            const reason = reasonOrCategory;
            data = {
                reasonToLoginCategory: reason.category,
                reasonToLoginName: reason.action,
                loginReason: reason
            };
        } else data = {
            reasonToLoginCategory: reasonOrCategory,
            reasonToLoginName: reasonName
        };
        if ((_window = window) === null || _window === void 0 ? void 0 : (_window_webkit = _window.webkit) === null || _window_webkit === void 0 ? void 0 : (_window_webkit_messageHandlers = _window_webkit.messageHandlers) === null || _window_webkit_messageHandlers === void 0 ? void 0 : _window_webkit_messageHandlers.onLoginEvent) window.webkit.messageHandlers.onLoginEvent.postMessage(JSON.stringify(data));
        if (typeof window.TV2JSBridge !== 'undefined' && typeof ((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_TV2JSBridge = _window1.TV2JSBridge) === null || _window_TV2JSBridge === void 0 ? void 0 : _window_TV2JSBridge.onLoginEvent) === 'function') window.TV2JSBridge.onLoginEvent(JSON.stringify(data));
    };
    const getLoggedInUser = async function() {
        try {
            const token = await getToken();
            if (!token) {
                (0, $313a413ce328ff04$export$baf306891f1b93bd)('appAuthToken');
                (0, $313a413ce328ff04$export$baf306891f1b93bd)('appUser');
                return;
            }
            const appUser = (0, $313a413ce328ff04$export$93d719890ad66653)('appUser');
            if (appUser) return appUser;
            const userResponse = await fetch(userApiUrl, {
                method: 'get',
                credentials: 'include',
                headers: new Headers({
                    Authorization: 'Bearer ' + token
                })
            });
            const user = await userResponse.json();
            (0, $313a413ce328ff04$export$5aa524d86254b4f)('appUser', user, 6);
            return user;
        } catch (e) {
            return;
        }
    };
    const getToken = async function() {
        var _window_webkit_messageHandlers, _window_webkit, _window, _window_TV2JSBridge;
        // IOS
        if ((_window = window) === null || _window === void 0 ? void 0 : (_window_webkit = _window.webkit) === null || _window_webkit === void 0 ? void 0 : (_window_webkit_messageHandlers = _window_webkit.messageHandlers) === null || _window_webkit_messageHandlers === void 0 ? void 0 : _window_webkit_messageHandlers.getToken) return await window.webkit.messageHandlers.getToken.postMessage('getToken');
        // Android
        if (typeof window.TV2JSBridge !== 'undefined' && typeof ((_window_TV2JSBridge = window.TV2JSBridge) === null || _window_TV2JSBridge === void 0 ? void 0 : _window_TV2JSBridge.getToken) === 'function') return await window.TV2JSBridge.getToken();
        var _getLocalStorageItem;
        // TODO: Remove when all apps are exposing native getToken()
        return (_getLocalStorageItem = (0, $313a413ce328ff04$export$93d719890ad66653)('appAuthToken')) !== null && _getLocalStorageItem !== void 0 ? _getLocalStorageItem : '';
    };
    const isAuthenticated = async function() {
        const token = await getToken();
        return !!(token && token !== '' && (token === null || token === void 0 ? void 0 : token.length) > 100);
    };
    const verifyEmail = async function() {
        try {
            const token = await getToken();
            const response = await fetch(`${userApiUrl}verifyEmail`, {
                method: 'POST',
                headers: new Headers({
                    Authorization: 'Bearer ' + token
                })
            });
            if (!response.ok || response.status !== 204) throw new Error(`User verification email failed: ${response.status}`);
            const user = await getLoggedInUser();
            return {
                success: true,
                message: 'Verification email sent',
                email: user === null || user === void 0 ? void 0 : user.email
            };
        } catch (e) {
            console.error('Menu: Error verifying email:', e);
            return {
                success: false,
                message: e.message
            };
        }
    };
    window.TV2 = (0, $258427eeb49655b2$export$71511d61b312f219)((0, $242f61281a4fc053$export$71511d61b312f219)({}, window.TV2), {
        login: login,
        getLoggedInUser: getLoggedInUser,
        getToken: getToken,
        isAuthenticated: isAuthenticated,
        verifyEmail: verifyEmail
    });
    const init = async function() {
        const user = await getLoggedInUser();
        const userId = user === null || user === void 0 ? void 0 : user.id;
        // Deprecated - still in use until all uses are updated to new event
        document.dispatchEvent(new CustomEvent('tv2-menu:auth0-ready', {
            detail: {
                app: true,
                isReady: true,
                userId: userId
            }
        }));
        // New event to take over for above event
        document.dispatchEvent(new CustomEvent('tv2-menu:auth-ready', {
            detail: {
                app: true,
                isReady: true,
                userId: userId
            }
        }));
    };
    init();
};




const $f82694444f488fe2$export$494eebab1bccae14 = ()=>{
    const { coralJwtUrl: coralJwtUrl } = window.AUTH0_CONFIG;
    const getCoralToken = async function() {
        try {
            var _window_TV2;
            // Get cached coral token first
            const cachedToken = localStorage.getItem('coral_token');
            const cachedExpiry = localStorage.getItem('coral_token_expiry');
            if (cachedToken && cachedExpiry && Date.now() < parseInt(cachedExpiry)) return cachedToken;
            // Get user data if not provided
            const user = await ((_window_TV2 = window.TV2) === null || _window_TV2 === void 0 ? void 0 : _window_TV2.getLoggedInUser());
            if (!user || !user.id || !user.email) throw new Error('User not authenticated or missing required fields');
            if (!user.emailConfirmed) throw new Error('User email not confirmed');
            // Request coral token from server
            const response = await fetch(coralJwtUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    user: user
                })
            });
            if (!response.ok) throw new Error(`Failed to get coral token: ${response.status}`);
            const data = await response.json();
            if (!data.success || !data.token) throw new Error('Invalid coral token response');
            // Store token and expiry in localStorage
            const expiryTime = Date.now() + data.expiresIn * 1000;
            localStorage.setItem('coral_token', data.token);
            localStorage.setItem('coral_token_expiry', expiryTime.toString());
            return data.token;
        } catch (error) {
            console.error('Menu: Error fetching Coral token:', error);
            // Clear any invalid cached tokens
            localStorage.removeItem('coral_token');
            localStorage.removeItem('coral_token_expiry');
        }
    };
    window.TV2 = window.TV2 || {};
    window.TV2 = (0, $258427eeb49655b2$export$71511d61b312f219)((0, $242f61281a4fc053$export$71511d61b312f219)({}, window.TV2), {
        getCoralToken: getCoralToken
    });
    getCoralToken();
};


const $410d84ca1ebf0031$var$init = ()=>{
    var _window, _window_webkit, _window1;
    /*
   * Menu is initially positioned as a block element to avoid CLS on page load.
   * When the page is loaded, we position the menu as a fixed and also add
   * top padding to the body equal to the menu height.
   */ const $menu = document.getElementById((0, $27650f335af3f4c5$export$c78050b59d0802b7));
    const $topNav = document.getElementById((0, $27650f335af3f4c5$export$5612978d35c19998));
    var _$topNav_getBoundingClientRect_height;
    const topNavHeight = Math.ceil((_$topNav_getBoundingClientRect_height = $topNav === null || $topNav === void 0 ? void 0 : $topNav.getBoundingClientRect().height) !== null && _$topNav_getBoundingClientRect_height !== void 0 ? _$topNav_getBoundingClientRect_height : 0);
    // Note: Since the sportsapp is the only app that has shared login, we differenciate beetween tv2no and sportsapp
    const useJSBridgeLogin = window.MENU_CONFIG.useJSBridgeLogin;
    const hasWebviewBrigde = ((_window = window) === null || _window === void 0 ? void 0 : _window.TV2JSBridge) || ((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_webkit = _window1.webkit) === null || _window_webkit === void 0 ? void 0 : _window_webkit.messageHandlers);
    const hasCoralUrl = window.AUTH0_CONFIG.coralJwtUrl && window.AUTH0_CONFIG.coralJwtUrl.length > 0;
    (0, $72d78183ba861693$export$89250341c2040c2d)($menu).then((menuHeight)=>{
        $menu === null || $menu === void 0 ? void 0 : $menu.classList.add('tv2-menu--fixed');
        document.body.style.paddingTop = menuHeight + 'px';
        if (document.documentElement.dataset.menuHideOnScroll !== 'false') (0, $0e87754269846f8f$export$dde0441bd4a6ded8)();
        (0, $97b4c742360fac72$export$5a86d273c3376191)();
        (0, $3b5dd35a8e8ee801$export$ca94e975f9255f98)();
        if (useJSBridgeLogin && hasWebviewBrigde) (0, $8935bf2b06df93ed$export$407a6a3870454386)();
        else (0, $86bc53116c439107$export$da4fc2bf424da4ca)();
        /*
     * Client side api for menu customizations (e.g. show/hide categories on mobile) will be handled
     * through custom events with the tv2-menu namespace/prefix.
     */ document.addEventListener('tv2-menu:show-mobile-categories', (0, $ccd1fa24fcb118d8$export$d9b45b5588c57e64));
        document.addEventListener('tv2-menu:hide-mobile-categories', (0, $ccd1fa24fcb118d8$export$c8ddb059529fd30a));
        /*
     * Let the world know that the menu is ready.
     */ const eventDetail = {
            $el: $menu,
            menuHeight: menuHeight,
            topNavHeight: topNavHeight,
            heightDiff: menuHeight - topNavHeight
        };
        const readyEvent = new CustomEvent('tv2-menu:ready', {
            detail: eventDetail
        });
        document.dispatchEvent(readyEvent);
        // Register the menuReady as a global variable
        window.TV2 = window.TV2 || {};
        window.TV2.MenuReady = function(dispatchEvent = false) {
            if (dispatchEvent) return document.dispatchEvent(readyEvent);
            return eventDetail;
        };
    });
    window.TV2 = window.TV2 || {};
    window.TV2.isAuthReady = async function() {
        // When in apps
        if (hasWebviewBrigde && useJSBridgeLogin) return true;
        return await (0, $ac9a226636de795d$export$eb86a8b8512b1ef2)();
    };
    // Handle Coral
    if (hasCoralUrl) document.addEventListener('tv2-menu:auth-ready', (0, $f82694444f488fe2$export$494eebab1bccae14));
};
if (document.readyState === 'complete') $410d84ca1ebf0031$var$init();
else document.addEventListener('DOMContentLoaded', $410d84ca1ebf0031$var$init);

var $242f61281a4fc053$export$71511d61b312f219;
"use strict";
var $f041aade5cadd016$export$71511d61b312f219;
"use strict";
function $f041aade5cadd016$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$f041aade5cadd016$export$71511d61b312f219 = $f041aade5cadd016$var$_define_property;


function $242f61281a4fc053$var$_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $f041aade5cadd016$export$71511d61b312f219(target, key, source[key]);
        });
    }
    return target;
}
$242f61281a4fc053$export$71511d61b312f219 = $242f61281a4fc053$var$_object_spread;

var $258427eeb49655b2$export$71511d61b312f219;
"use strict";
function $258427eeb49655b2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $258427eeb49655b2$var$_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $258427eeb49655b2$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
$258427eeb49655b2$export$71511d61b312f219 = $258427eeb49655b2$var$_object_spread_props;


//# sourceMappingURL=menu.js.map
